// import React, { useEffect, useState } from "react";
import { toast } from "../../utils/toast";
// import "../styles/CouponManagementPage.css";
// import MyPageSidebar from "./MyPageSidebar";
// import UserProfile from "./UserProfile";
// import Pagination from "../common/Pagination";
//
// const CouponManagementPage = () => {
//     const [activeTab, setActiveTab] = useState("미사용"); // ✅ 기본값: 미사용 쿠폰
//     const [availableCoupons, setAvailableCoupons] = useState([]);
//     const [usedCoupons, setUsedCoupons] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [totalPages, setTotalPages] = useState(0);
//     const pageSize = 4; // 한 페이지에 표시할 쿠폰 수
//
//     useEffect(() => {
//         fetchCoupons();
//     }, []);
//
//     const fetchCoupons = async () => {
//         setIsLoading(true);
//         try {
//             const response = await fetch("/api/coupon");
//             if (response.ok) {
//                 const data = await response.json();
//                 console.log("API 응답 데이터:", data); // 디버깅용 로그
//
//                 if (data.availableCoupons) {
//                     setAvailableCoupons(data.availableCoupons || []);
//                 }
//                 if (data.usedCoupons) {
//                     setUsedCoupons(data.usedCoupons || []);
//                 }
//
//                 // 현재 탭에 따라 총 페이지 수 계산
//                 const coupons = activeTab === "미사용" ? data.availableCoupons : data.usedCoupons;
//                 setTotalPages(Math.ceil((coupons?.length || 0) / pageSize));
//             } else {
//                 console.error("쿠폰 데이터를 불러오는데 실패했습니다.");
//             }
//         } catch (error) {
//             console.error("API 요청 중 오류 발생:", error);
//         } finally {
//             setIsLoading(false);
//         }
//     };
//
//     const handleTabChange = (tab) => {
//         setActiveTab(tab);
//         setCurrentPage(0); // 탭 변경 시 첫 페이지로 이동
//
//         // 탭 변경 시 총 페이지 수 재계산
//         const coupons = tab === "미사용" ? availableCoupons : usedCoupons;
//         setTotalPages(Math.ceil((coupons?.length || 0) / pageSize));
//     };
//
//     const handlePageChange = (page) => {
//         setCurrentPage(page);
//     };
//
//     if (isLoading) return <p>로딩중...</p>;
//
//     // 현재 탭에 따라 쿠폰 필터링 및 페이지네이션 적용
//     const allCoupons = activeTab === "미사용" ? availableCoupons : usedCoupons;
//     const startIndex = currentPage * pageSize;
//     const endIndex = startIndex + pageSize;
//     const paginatedCoupons = allCoupons.slice(startIndex, endIndex);
//
//     // 총 쿠폰 수
//     const totalCoupons = allCoupons.length;
//
//     // 쿠폰 없을때, "쿠폰이 없습니다." 메시지 표시
//     if (allCoupons === "noData") {
//         return (
//             <div className="coupon-container">
//                 <MyPageSidebar />
//                 <div className="coupon-content">
//                     <h2 className="mypage-title">마이페이지</h2>
//                     <UserProfile />
//                     <h2 className="coupon-title">쿠폰 0개</h2>
//                     {/* ✅ 탭 버튼 */}
//                     <div className="coupon-tabs">
//                         <div className={`tab-slider ${activeTab === "사용됨" ? "move-right" : ""}`}></div>
//
//                         <button className={`tab-btn ${activeTab === "미사용" ? "active" : ""}`}
//                                 onClick={() => handleTabChange("미사용")}>
//                             사용 가능 쿠폰
//                         </button>
//                         <button className={`tab-btn ${activeTab === "사용됨" ? "active" : ""}`}
//                                 onClick={() => handleTabChange("사용됨")}>
//                             사용한 쿠폰
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
//
//     return (
//         <div className="coupon-container">
//             <MyPageSidebar />
//             <div className="coupon-content">
//                 <h2 className="mypage-title">마이페이지</h2>
//                 <UserProfile />
//
//                 {/* ✅ 쿠폰 개수 */}
//                 <h2 className="coupon-title">쿠폰 {totalCoupons}개</h2>
//
//                 {/* ✅ 탭 버튼 */}
//                 <div className="coupon-tabs">
//                     <div className={`tab-slider ${activeTab === "사용됨" ? "move-right" : ""}`}></div>
//
//                     <button className={`tab-btn ${activeTab === "미사용" ? "active" : ""}`}
//                             onClick={() => handleTabChange("미사용")}>
//                         사용 가능 쿠폰
//                     </button>
//                     <button className={`tab-btn ${activeTab === "사용됨" ? "active" : ""}`}
//                             onClick={() => handleTabChange("사용됨")}>
//                         사용한 쿠폰
//                     </button>
//                 </div>
//
//                 {/* ✅ 쿠폰 리스트 */}
//                 <div className="coupon-list">
//                     {paginatedCoupons.length > 0 ? (
//                         paginatedCoupons.map((coupon, index) => (
//                             <div key={`${coupon.couponId}-${index}`} className="coupon-card">
//                                 <div className="coupon-content-left">
//                                     <h3 className="coupon-title-text">{coupon.name}</h3>
//                                     <p className="coupon-subtitle">{coupon.description}</p>
//                                     <h2 className="coupon-discount">
//                                         {coupon.discountRate > 0
//                                             ? `${coupon.discountRate}% 할인`
//                                             : `${coupon.discountAmount.toLocaleString()}원 할인`}
//                                     </h2>
//                                     <p className="coupon-expiration">{coupon.expirationDate}까지</p>
//                                 </div>
//                                 {/* ✅ 사용 여부에 따른 이미지 변경 */}
//                                 <img
//                                     src={activeTab === "미사용"
//                                         ? "/images/icon/coupon_not_used.png"
//                                         : "/images/icon/coupon_used.png"}
//                                     alt={activeTab === "사용됨" ? "사용됨" : "미사용"}
//                                     className="coupon-status-image"
//                                 />
//                             </div>
//                         ))
//                     ) : (
//                         <p className="no-coupons">쿠폰이 없습니다.</p>
//                     )}
//                 </div>
//
//                 {/* 페이지네이션 */}
//                 {totalPages > 1 && (
//                     <Pagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={handlePageChange}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
//
// export default CouponManagementPage;

import React, { useState, useEffect } from "react";
import "../styles/CouponManagementPage.css";
import MyPageSidebar from "./MyPageSidebar";
import UserProfile from "./UserProfile";
import Pagination from "../common/Pagination";

const CouponManagementPage = () => {
    const [activeTab, setActiveTab] = useState("미사용");
    const [coupons, setCoupons] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCoupons, setTotalCoupons] = useState(0);
    const pageSize = 4;

    // 쿠폰 데이터 조회 함수
    const fetchCoupons = async () => {
        setIsLoading(true);
        try {
            const status = activeTab === "미사용" ? "unused" : "used";
            const response = await fetch(`/api/coupon?page=${currentPage}&size=${pageSize}&status=${status}`);

            if (response.ok) {
                const data = await response.json();

                // API 응답 구조에 따라 데이터 설정
                if (data && Array.isArray(data.content)) {
                    setCoupons(data.content);
                    setTotalPages(data.totalPages || 0);
                    setTotalCoupons(data.totalElements || 0);
                } else if (data && data.availableCoupons && activeTab === "미사용") {
                    setCoupons(data.availableCoupons);
                    setTotalCoupons(data.availableCoupons.length);
                    setTotalPages(Math.ceil(data.availableCoupons.length / pageSize));
                } else if (data && data.usedCoupons && activeTab === "사용됨") {
                    setCoupons(data.usedCoupons);
                    setTotalCoupons(data.usedCoupons.length);
                    setTotalPages(Math.ceil(data.usedCoupons.length / pageSize));
                } else {
                    setCoupons([]);
                    setTotalPages(0);
                    setTotalCoupons(0);
                }
            } else {
                console.error("쿠폰 데이터를 불러오는데 실패했습니다.");
                setCoupons([]);
            }
        } catch (error) {
            console.error("API 요청 중 오류 발생:", error);
            setCoupons([]);
        } finally {
            setIsLoading(false);
        }
    };

    // 탭 변경 시 데이터 다시 조회
    useEffect(() => {
        fetchCoupons();
    }, [activeTab, currentPage]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(0); // 탭 변경 시 첫 페이지로 이동
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // 쿠폰 사용 함수
    const handleUseCoupon = async (couponId) => {
        try {
            const response = await fetch(`/api/coupon/use/${couponId}`, {
                method: 'POST'
            });

            if (response.ok) {
                toast("쿠폰이 사용되었습니다.");
                // 쿠폰 목록 새로고침
                fetchCoupons();
            } else {
                toast("쿠폰 사용에 실패했습니다.");
            }
        } catch (error) {
            console.error("쿠폰 사용 중 오류 발생:", error);
            toast("쿠폰 사용 중 오류가 발생했습니다.");
        }
    };

    // 현재 페이지에 표시할 쿠폰 계산 (클라이언트 측 페이지네이션)
    const paginatedCoupons = coupons.slice(currentPage * pageSize, (currentPage + 1) * pageSize);

    if (isLoading && currentPage === 0) return <p>로딩중...</p>;

    return (
        <div className="coupon-container">
            <MyPageSidebar />
            <div className="coupon-content">
                <h2 className="mypage-title">마이페이지</h2>
                <UserProfile />

                <h2 className="coupon-title">쿠폰 {totalCoupons}개</h2>

                <div className="sc-tabs">
                    {["미사용", "사용됨"].map((key) => (
                        <button
                            key={key}
                            type="button"
                            className={`sc-tab${activeTab === key ? " sc-tab--active" : ""}`}
                            onClick={() => handleTabChange(key)}
                            aria-selected={activeTab === key}
                            role="tab"
                        >
                            {key === "미사용" ? "사용 가능 쿠폰" : "사용한 쿠폰"}
                        </button>
                    ))}
                </div>

                <div className="coupon-list">
                    {paginatedCoupons.length > 0 ? (
                        paginatedCoupons.map((coupon, index) => (
                            <div key={`${coupon.couponId || coupon.id}-${index}`} className={`coupon-card${activeTab === "사용됨" ? " sc-choice--disabled" : ""}`}>
                                <div className="coupon-content-left">
                                    <h3 className="coupon-title-text">{coupon.name}</h3>
                                    <p className="coupon-subtitle">{coupon.description}</p>
                                    <h2 className="coupon-discount">
                                        {coupon.discountRate > 0
                                            ? `${coupon.discountRate}% 할인`
                                            : `${coupon.discountAmount.toLocaleString()}원 할인`}
                                    </h2>
                                    <p className="coupon-expiration">{coupon.expirationDate}까지</p>
                                </div>

                                {activeTab === "미사용" ? (
                                    <button
                                        className="coupon-use-button"
                                        onClick={() => handleUseCoupon(coupon.couponId || coupon.id)}
                                    >
                                        사용하기
                                    </button>
                                ) : (
                                    <img
                                        src="/images/icon/coupon_used.png"
                                        alt="사용됨"
                                        className="coupon-status-image"
                                    />
                                )}
                            </div>
                        ))
                    ) : (
                        <p className="no-coupons">쿠폰이 없습니다.</p>
                    )}
                </div>

                {totalPages > 1 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
            </div>
        </div>
    );
};

export default CouponManagementPage;
